
<div v-if="dashboardDrilldownFilters != null && dashboardDrilldownFilters.length" class="mt-3">
  <div class="font-weight-bold text-charcoal mb-1">
    <template v-if="showFilterWarning">
      <icon class="exclamation-circle" :data-c-tooltip="`Predefined filter on list view may conflict with this data point. Check your list view's configurations.`"></icon>
    </template>
    Filtered by ({{ dashboardDrilldownFilters.length }}):
  </div>
  <pill
    v-for="filterObj in dashboardDrilldownFilters"
    :value="`${filterObj.filter_display}`"
    :key="filterObj.id"
    :data-c-tooltip="filterObj.property_display"
    color="Orange"
    @onRemove="remove(filterObj)">
  </pill>
</div>
